import React, { useState } from "react";
import _ from "lodash";
import Form from "forms/Form";
import { CHANGE_PASSWORD } from "api/config/endpoints";
import formWrapper from "hoc/formWrapper";
import { InlineNotification, ListItem, Loading, UnorderedList } from "carbon-components-react";

const ChangePasswordForm = ({ hideCloseButton, onRequestClose, ...props }) => {
    const [saving, setSaving] = useState(false);
    const [defaultValues, setDefaultValues] = useState({});
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true);

    const getValue = (name, type) => {
        const value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;
        switch (type) {
            case "bool":
                return (value !== 0 && value !== null && value !== undefined);
            default:
                return value;
        }
    };

    const getEndpoint = () => {
        return `${CHANGE_PASSWORD}`
    }

    const onSubmit = async () => {
        if (props.onSubmit) {
            props.onSubmit()
        }
    }

    const onTouch = () => {
        setSubmitButtonDisabled(false)
    }

    let fields = [
        {
            elementType: "password",
            helperText: "Type your current password to confirm this actions",
            id: "old_password",
            name: "old_password",
            // invalidText: "This must be a valid email address",
            labelText: "Current Password",
            placeholder: "Insert your current password",
            value: getValue("old_password"),
            rules: {
                pattern:
                    "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$",
            },
        },
        {
            elementType: "password",
            helperText: "Type your new password following the rules you found above",
            id: "password",
            name: "password",
            // invalidText: "This must be a valid email address",
            labelText: "New Password",
            placeholder: "Insert your new password",
            value: getValue("password"),
            rules: {
                pattern:
                    "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$",
            },
        },
        {
            elementType: "password",
            // helperText: "Retype your new password",
            id: "password_confirmation",
            name: "password_confirmation",
            // invalidText: "This must be a valid email address",
            labelText: "Confirm new Password",
            placeholder: "Re-type your new password",
            value: getValue("password_confirmation"),
            rules: {
                pattern:
                    "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$",
            },
        },

    ]

    const onChange = (key, value) => {
        setDefaultValues({
            ...defaultValues,
            [key]: value
        });
    }

    const onSavingChange = (value) => {
        setSaving(value)
    }

    const defaultParams = () => {
        return {}
    }

    const getExtraContents = () => {
        return (
            <div style={{ paddingBottom: "1rem" }}>
                <a href="https://support.adam-webcast.com/how-to/change-password" target="_blank">Support page with instructions</a>
                <div style={{ paddingBottom: "0.5rem" }}>
                    <InlineNotification
                        kind="warning"
                        title={<strong>Remember!</strong>}
                        subtitle={"Once the password has been changed, all your user active sessions will be closed and you will have to log-in again."}
                        hideCloseButton
                        lowContrast />
                </div>
            </div>
        )
    }

    return (
        <div className={props.className}>
            {
                saving ? <Loading /> : null
            }
            <Form
                blockTouched={true}
                fields={fields}
                endpoint={getEndpoint()}
                loaded={true}
                modal={true}
                onRequestClose={onRequestClose}
                onSavingChange={(value) => onSavingChange(value)}
                onChange={(key, val) => onChange(key, val)}
                defaultParams={defaultParams()}
                onSubmit={() => onSubmit()}
                danger={true}
                hideCloseButton={hideCloseButton}
                submitButtonDisabled={submitButtonDisabled}
                onTouch={onTouch}
                extraContents={getExtraContents()}
            />    
        </div>
    );
};

export default formWrapper(ChangePasswordForm);
